var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"footer"}},[_vm._v(" All Content © Mel Edelman "),_c('br'),_vm._v(" All Rights Reserved ")])}]

export { render, staticRenderFns }